<template>
  <Layout>
    <PageHeader title="Tambah Kategori Video" pageTitle="KMS" />

    <div class="card">
      <div class="card-body">
        <form @submit.prevent="submit">

          <!-- Nama -->
          <div class="form-group">
            <label>
              Nama Kategori <span class="text-danger">*</span>
            </label>
            <input
              v-model="form.name"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errors.name }"
              placeholder="Contoh: Manajemen, Leadership, Teknis"
            />
            <div v-if="errors.name" class="invalid-feedback">
              {{ errors.name }}
            </div>
          </div>

          <!-- Deskripsi -->
          <div class="form-group">
            <label>Deskripsi</label>
            <textarea
              v-model="form.description"
              rows="3"
              class="form-control"
              placeholder="Deskripsi singkat kategori (opsional)"
            ></textarea>
          </div>

          <!-- Status -->
          <div class="form-group">
            <label>Status</label>
            <div class="custom-control custom-switch">
              <input
                type="checkbox"
                class="custom-control-input"
                id="is_active"
                v-model="form.is_active"
              />
              <label class="custom-control-label" for="is_active">
                {{ form.is_active ? 'Aktif' : 'Nonaktif' }}
              </label>
            </div>
          </div>

          <!-- Action -->
          <div class="d-flex justify-content-end mt-4">
            <button
              type="button"
              class="btn btn-secondary mr-2"
              @click="goBack"
              :disabled="loading"
            >
              Batal
            </button>

            <button
              type="submit"
              class="btn btn-primary"
              :disabled="loading"
            >
              <i v-if="loading" class="mdi mdi-loading mdi-spin"></i>
              Simpan
            </button>
          </div>

        </form>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  components: { Layout, PageHeader },

  data() {
    return {
      loading: false,
      form: {
        name: "",
        description: "",
        is_active: true,
      },
      errors: {},
    };
  },

  methods: {
    getAuthHeader() {
      const token = localStorage.getItem("access_token");
      return {
        Authorization: `Bearer ${token}`,
      };
    },

    validate() {
      this.errors = {};

      if (!this.form.name) {
        this.errors.name = "Nama kategori wajib diisi";
      } else if (this.form.name.length < 3) {
        this.errors.name = "Nama kategori minimal 3 karakter";
      }

      return Object.keys(this.errors).length === 0;
    },

    async submit() {
      if (!this.validate()) return;

      this.loading = true;
      this.errors = {};

      try {
        await axios.post(
          `${process.env.VUE_APP_BACKEND_URL_VERSION}master/kms/video/kategori`,
          this.form,
          {
            headers: this.getAuthHeader(),
          }
        );

        await Swal.fire({
          icon: "success",
          title: "Berhasil",
          text: "Kategori video berhasil ditambahkan",
        });

        this.$router.push({ name: "kms-video-kategori-list" });

      } catch (err) {
        console.error(err);

        if (err.response?.status === 422) {
          const backendErrors = err.response.data?.errors || {};
          Object.keys(backendErrors).forEach((key) => {
            this.errors[key] = backendErrors[key][0];
          });
        } else if (err.response?.status === 401) {
          Swal.fire(
            "Session Expired",
            "Silakan login ulang",
            "warning"
          ).then(() => {
            this.$router.push({ name: "login" });
          });
        } else {
          Swal.fire("Error", "Gagal menyimpan kategori", "error");
        }
      } finally {
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: "kms-video-kategori-list" });
    },
  },
};
</script>

<style scoped>
.form-group label {
  font-weight: 600;
}
</style>
